import {useTranslation} from 'react-i18next';
import EventArrowIconV4 from './EventArrowIconV4';
import EventRowItemV4 from './EventRowItemV4';
import ModuleSectionV4 from './ModuleSectionV4';
import SingleText from '../../common/component/SingleText';
import {showShareAlert} from '../../common/container/ShareAlert';
import useTypedSelector from '../../common/hook/useTypedSelector';
import useEventPageEvent from '../hook/useEventPageEvent';
import {IShareModuleV4} from '../type';

interface IProps {
  data: IShareModuleV4;
}

export default function ShareModuleV4({data}: IProps) {
  const {t} = useTranslation();
  const {section} = data;
  const eventTitle = useTypedSelector(
    state => state.event.moduleMap.event?.commonModule.eventTitle ?? ''
  );

  const sendEventPageEvent = useEventPageEvent();
  const handleClick = () => {
    sendEventPageEvent({actionName: 'share'});
    showShareAlert({text: eventTitle});
  };

  return (
    <ModuleSectionV4 data-module-type={data.moduleType} section={section}>
      <EventRowItemV4
        isRound
        className="bg-white gap-x-10 cursor-pointer"
        leftElementClassName="flex-auto"
        leftElement={
          <SingleText className="s15-bold-black leading-19 tracking-[-0.4px]">
            {t('crm_share_button')}
          </SingleText>
        }
        rightElementClassName="flex-shrink-0"
        rightElement={<EventArrowIconV4 />}
        onClick={handleClick}
      />
    </ModuleSectionV4>
  );
}
